import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import Icon, { ICONS } from "@/components/Core/Icons";

const isDev = import.meta.env.VITE_ENVIRONMENT === "DEV";
const isStaging = import.meta.env.VITE_ENVIRONMENT === "STAGING";

export default function MaintenanceModal() {
  const [maintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
    const checkMaintenanceStatus = async () => {
      if (isDev || isStaging) {
        return;
      }
      try {
        const cacheBuster = Date.now();
        const response = await fetch(
          `https://storage.googleapis.com/tempo-maintenance/maintenance.json?v=${cacheBuster}`,
        );
        if (response.ok) {
          const data = await response.json();

          if (data.skipDomain === window.location.hostname) {
            setMaintenanceMode(false);
            return;
          }

          if (data.redirectTo) {
            window.location.href = `${window.location.protocol}//${data.redirectTo}${window.location.pathname}${window.location.search}`;
            return;
          }

          setMaintenanceMode(data.maintenance || false);
        }
      } catch (error) {
        console.error("Failed to check maintenance status:", error);
        // On error, don't change the current state to avoid flashing
      }
    };

    // Check immediately when component mounts
    checkMaintenanceStatus();

    // Set up interval to check every minute (60000ms)
    const interval = setInterval(checkMaintenanceStatus, 60000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  // Don't render anything if maintenance mode is not active
  if (!maintenanceMode) {
    return null;
  }
  return (
    <Dialog open={maintenanceMode}>
      <DialogContent
        hideClose
        hideOverlay
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-9999 flex items-center justify-center bg-[#131519] max-w-none w-screen h-screen border-none shadow-none p-0 m-0 data-[state=open]:animate-none opacity-90"
      >
        <div className="relative flex flex-col items-center justify-center text-center space-y-8 z-10">
          {/* Tempo Logo */}
          <Icon
            icon={ICONS.TEMPO_LOGO_WHITE}
            className="w-[50px] h-[50px] opacity-30"
          />

          {/* Main Message */}
          <div className="space-y-4">
            <h1 className="text-4xl font-bold text-[#F5F5F6]">We'll be back</h1>
            {/* Gradient divider */}
            <div className="h-px bg-linear-to-r from-transparent via-gray-400 to-transparent w-full"></div>
            <p className="text-lg max-w-md text-[#9F9FA4]">
              Tempo is currently undergoing maintenance. We'll be back online
              shortly.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
